// extracted by mini-css-extract-plugin
export default {"content":"Html_content__Io7ma","HtmlContainer":"Html_HtmlContainer__54iWn"};